import MultiOrgRender from './MultiOrgRender';

export default MultiOrgRender;
